import React from "react";

type Props = { className?: string; size?: number };

const LogoutIcon: React.FC<Props> = ({ className, size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      stroke="#9F9FA6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.513 6.158V5.38a3.071 3.071 0 0 0-3.07-3.07H5.38a3.07 3.07 0 0 0-3.07 3.07v9.275a3.07 3.07 0 0 0 3.07 3.071h4.07c1.692 0 3.063-1.37 3.063-3.061v-.786M18.175 10.018H8.14M15.734 7.589l2.44 2.429-2.44 2.43"
    />
  </svg>
);

export default LogoutIcon;
